angular.module('jv.cand.details.rank.directive', [])
.directive('candidateRankMatch', ['i18n', function(i18n) {
    return {
        restrict: 'A',
        scope: {
            rankDetails: '=ngModel',
            jobtitle: '=jobtitle'
        },
        templateUrl: '/jhire/htm/common/applicationRankScore.html',
        link: function(scope) {
            scope.isNextGenUIEnabled = window.isnextGenUIEnabled === 'true';
            scope.rank = [i18n.RANK_V_WEAK, i18n.RANK_V_WEAK, i18n.RANK_WEAK, i18n.RANK_AVG, i18n.RANK_STRONG, i18n.RANK_V_STRONG];
            scope.getCeil = function(num){
                if(num == null){
                    return null;
                }
                return Math.ceil(num);
            };
            scope.i18n = i18n;

        }
    };
}]);